import { Box } from "@mui/material"
import { format, fromUnixTime } from "date-fns"
import React from "react"
import { useTranslation } from "react-i18next"
import Text from "src/components/Text"
import boostPools from "src/constants/boostPools"
import { formatLockPeriod } from "../../helpers"

interface Props {
  currentPool: number
  selectedPool: number
  lastUnlockTime: number
}

const UpgradeDetails = ({
  currentPool,
  selectedPool,
  lastUnlockTime,
}: Props) => {
  const { t } = useTranslation()
  const currentPoolInfo = boostPools.find((pool) => pool.pid === currentPool)
  const selectedPoolInfo = boostPools.find((pool) => pool.pid === selectedPool)
  const delta =
    selectedPoolInfo && currentPoolInfo
      ? selectedPoolInfo.lockPeriod - currentPoolInfo.lockPeriod
      : 0
  const endDate = fromUnixTime(lastUnlockTime + delta)

  return (
    <Box>
      {currentPoolInfo && (
        <Box display="flex" justifyContent="space-between" mt={3}>
          <Text>{`${t("Current Vault")} (${formatLockPeriod(
            currentPoolInfo.lockPeriod,
          )})`}</Text>
          <Text>{currentPoolInfo.multiplier / 100}x</Text>
        </Box>
      )}
      {selectedPoolInfo && (
        <Box display="flex" justifyContent="space-between" mt={1}>
          <Text>{`${t("Target Vault")} (${formatLockPeriod(
            selectedPoolInfo.lockPeriod,
          )})`}</Text>
          <Text>{selectedPoolInfo.multiplier / 100}x</Text>
        </Box>
      )}
      <Box display="flex" justifyContent="space-between" mt={1} mb={3}>
        <Text>{`${t("Lock End Date")}`}</Text>
        <Text>{format(endDate, "MMM dd, yyyy")}</Text>
      </Box>
    </Box>
  )
}

export default UpgradeDetails
